module.exports = __webpack_public_path__ + "static/media/perfect.927276ea.jpg";